export const OnboardingIcon: React.FC<any> = ({ className }) => {
   return (
      <div
         className={`${className} `}
         dangerouslySetInnerHTML={{
            __html: `
         <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
         <path d="M6.64111 6.00002L11.4277 11L21 1M1 6.00002L5.78664 11M15.3599 1L11.7181 4.83888" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
         </svg>
     `,
         }}
      />
   )
}
